import icons from '../../config/icons.config'
import AppIcon from '../icons/AppIcon'
import styles from './StatusChip.module.css'

export type StatusChipVariant = 'done' | 'next' | 'locked' | 'finish'

const LABELS: Record<StatusChipVariant, string> = {
  done: 'Cleared',
  next: 'Next',
  locked: 'Locked',
  finish: 'Finish',
}

const CHIP_ICONS: Record<StatusChipVariant, string> = {
  done: icons.checkCircle,
  next: icons.map,
  locked: 'mdi:lock',
  finish: icons.trophy,
}

interface StatusChipProps {
  variant: StatusChipVariant
}

export default function StatusChip({ variant }: StatusChipProps) {
  return (
    <span className={[styles.chip, styles[variant]].join(' ')}>
      <AppIcon icon={CHIP_ICONS[variant]} size={12} />
      {LABELS[variant]}
    </span>
  )
}
